module.exports = __webpack_public_path__ + "media/heartSound2.ed337a9a.mp3";